import { transition } from '@helpers/animate';
import { ButtonReset } from '@helpers/global';
import styled from 'styled-components';
const Button = styled.button `
  ${ButtonReset};
  ${transition('background-color')};

  position: absolute;
  top: 0;
  right: 0;
  display: grid;
  background: var(--bgColor);
  color: var(--fgColor);
  height: var(--buttonSize);
  place-content: center;
  place-items: center;
  width: var(--buttonSize);
  z-index: 1;
  transform: translateY(calc(-100% + 1px));
  padding: 4px;

  svg {
    ${transition('opacity')};

    display: block;
    height: 100%;
    width: 100%;
  }

  &.focus-ring {
    outline: auto;
  }

  &:hover {
    background-color: var(--bgColorHover, var(--bgColor));

    svg {
      opacity: 0.65;
    }
  }
`;
const CloseStyles = {
    Button,
};
export default CloseStyles;
